import { store } from './store.js';
import { en, fr } from 'vuejs-datepicker/dist/locale';

export var shared = {
  filters: {
      formatDate: function (value) {
          return moment(value).format('YYYY/MM/DD');
      },
      formatDateTime: function (value) {
          return moment(value).format('YYYY/MM/DD hh:mm A');
      }
  },
  methods: {
    getCustomerLabel: function (key) {
      var label = store.getCustomerLabel(key);
      return label;
    },
    getLabel: function (key) {
      var label = store.getLabel(key);
      return label;
    },
    fixImage: function (value) {
      if (!value) {
          return '';
      }

      return value.replace('~', '');
    }
},
computed: {
  language: function () {
    switch (store.state.settings.langId) {
        case "1":
            return en;
            break;
        case "2":
            return fr;
            break;
        default:
            return en;
            break;
    }
  }
}
}